import { t, requireKeyOrExplain } from '../common.js';

const notice = document.getElementById('key-notice');
const nav = document.getElementById('nav');
const serverStatus = document.getElementById('server-status');

const hasKey = requireKeyOrExplain(notice);
if (!hasKey) nav.classList.add('hidden');

Object.defineProperty(window, '__lab', {
  value: Object.freeze({ page: 'index', hasKey }),
  configurable: true,
});

async function checkHealth() {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), 5000);
  let ok = false;
  try {
    const res = await fetch('/api/health', { cache: 'no-store', signal: ctrl.signal });
    const body = res.ok ? await res.json() : null;
    ok = Boolean(body && body.ok);
  } catch {
    ok = false;
  } finally {
    clearTimeout(timer);
  }
  serverStatus.textContent = ok ? t.serverOk : t.serverDown;
  serverStatus.classList.remove('ok', 'bad');
  serverStatus.classList.add(ok ? 'ok' : 'bad');
}

checkHealth();
